import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { api } from "../../lib/api";
import { GalleryWall } from "../../components/art/GalleryWall";

const REACTIONS = [["love", "❤️", "喜歡"], ["clap", "👏", "好棒"], ["star", "⭐", "太厲害了"], ["paint", "🎨", "繼續畫"]];

const Reactions = ({ token, w, onDone }) => {
  const key = `zq_react_${token}_${w.work_id}`;
  const [mine, setMine] = useState(localStorage.getItem(key));
  const send = async (r) => {
    if (mine) return;
    await api.post(`/public/art/${token}/react`, { work_id: w.work_id, reaction: r });
    localStorage.setItem(key, r);
    setMine(r);
    onDone(w.work_id, r);
  };
  return (
    <div className="flex flex-wrap gap-2" data-testid={`share-reactions-${w.work_id}`}>
      {REACTIONS.map(([k, e, l]) => (
        <button key={k} data-testid={`share-react-${k}-${w.work_id}`} onClick={() => send(k)} disabled={!!mine}
          className={`h-11 px-3 rounded-full border-2 font-bold flex items-center gap-1 ${mine === k ? "bg-amber-100 border-amber-400" : "bg-white border-stone-200"}`}>
          {e} {l} <span className="text-stone-500">{w.counts?.[k] || 0}</span>
        </button>
      ))}
    </div>
  );
};

export default function ArtSharePublic() {
  const { token } = useParams();
  const [d, setD] = useState(null);
  const [err, setErr] = useState("");
  useEffect(() => { api.get(`/public/art/${token}`).then((r) => setD(r.data)).catch((e) => setErr(e?.response?.data?.detail || "找不到這個分享")); }, [token]);
  const bump = (id, r) => setD((x) => ({ ...x, works: x.works.map((w) => (w.work_id === id ? { ...w, counts: { ...w.counts, [r]: (w.counts?.[r] || 0) + 1 } } : w)) }));
  return (
    <div className="min-h-screen bg-[#FFF8EE] font-round" data-testid="art-share-public-page">
      <header className="max-w-6xl mx-auto px-6 py-6 flex items-center justify-between">
        <Link to="/" className="font-brush text-3xl text-[#C0392B]" data-testid="share-brand-link">小書童畫坊</Link>
        <Link to="/" className="h-11 px-5 rounded-full bg-[#C0392B] text-white font-bold flex items-center" data-testid="share-visit-btn">認識小書童</Link>
      </header>
      <main className="max-w-6xl mx-auto px-6 pb-16">
        {err && <div className="text-center py-24 text-2xl text-stone-500" data-testid="share-error">{err}</div>}
        {d && (<>
          <h1 className="text-4xl sm:text-5xl font-black text-[#7a2e12] mb-2" data-testid="share-title">{d.nickname ? `${d.nickname} 的小畫廊` : "小畫家的畫廊"}</h1>
          <p className="text-stone-500 mb-6">點一下作品可以放大欣賞{d.reactions ? "，也可以送上鼓勵" : ""}。</p>
          {d.works.length ? <GalleryWall works={d.works} wall={d.wall} footer={d.reactions ? (w) => <Reactions token={token} w={d.works.find((x) => x.work_id === w.work_id)} onDone={bump} /> : undefined} />
            : <div className="text-center py-20 text-stone-500" data-testid="share-empty">這裡還沒有作品。</div>}
        </>)}
      </main>
    </div>
  );
}
